import datetimeDecorator from 'src/decorators/datetime.decorator';
import { datetimeUtil } from 'src/utils/datetime.util';

import { formatPlanDuration } from './formatPlanDuration';

const hhmm = (date: Date | null): string => (date ? datetimeDecorator.toHourMinutes(date) ?? '--:--' : '--:--');

/**
 * 展開行ヘッダーの「計画」に出す時刻レンジと所要。旧マップ (/plans) の
 * PlanningsDelivery.presenter.tsx:902-946 と同じ組み立てにする (log_web_issues#310)。
 *
 * - 開始と終了が別日なら `MM/DD` を添える。夜間勤務は日跨ぎが普通で、HH:mm だけだと
 *   22:14 と 03:51 のどちらが先か読めない
 * - 所要はアイドル時間を差し引き、差し引いたことを併記する。黙って引くと
 *   「時刻の差と合わない」と読まれる
 *
 * 同日判定は旧マップと同じ datetimeUtil.isSameDay（ローカル日付）を使う。
 * toYyyyMmDd 経由にすると Asia/Tokyo 指定の経路に乗り、HH:mm を出す
 * toHourMinutes（timeZone が効かずローカル）と食い違う余地が残る。
 */
export function formatPlanRange(start: Date | null, end: Date | null, idleSeconds = 0): string {
  const sameDay = !start || !end || datetimeUtil.isSameDay(start, end);
  const label = (date: Date | null) => (
    sameDay || !date ? hhmm(date) : `${datetimeDecorator.toMmDd(date)} ${hhmm(date)}`
  );

  const duration = formatPlanDuration(start, end, idleSeconds);
  const idleMinutes = idleSeconds > 0 ? Math.ceil(idleSeconds / 60) : 0;

  return [
    `${label(start)}~${label(end)}`,
    duration ? ` (${duration})` : '',
    idleMinutes > 0 ? ` ※アイドル時間${idleMinutes}分を除外` : '',
  ].join('');
}
